module.exports = __webpack_public_path__ + "static/media/learning-13.8574821c.png";